export const SPLASH_SCREEN_TIMING = {
  logo: 300,
  textLine1: 600,
  textLine2: 900,
  underlineAndImages: 1200,
  ready: 2400,
  fadeOutDuration: 1800,
} as const;

export const SPLASH_SCREEN_SHOWN_KEY = 'parkapp_splash_screen_shown';
